/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PickUserInfoEmailFirstnameLastnameTitleCodeLanguageCountryCode } from './pickUserInfoEmailFirstnameLastnameTitleCodeLanguageCountryCode';


/**
 * 
 */
export interface LocationAdminCreateOrUpdateContactBody { 
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    userId?: number;
    /**
     * 
     */
    subscriptionId?: number;
    /**
     * 
     */
    departmentId: number;
    newUser?: PickUserInfoEmailFirstnameLastnameTitleCodeLanguageCountryCode;
    /**
     * 
     */
    startDate: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    type: LocationAdminCreateOrUpdateContactBody.TypeEnum;
}
export namespace LocationAdminCreateOrUpdateContactBody {
    export type TypeEnum = 'internship-evaluation-interuniversity' | 'supervisor-quality-survey';
    export const TypeEnum = {
        InternshipEvaluationInteruniversity: 'internship-evaluation-interuniversity' as TypeEnum,
        SupervisorQualitySurvey: 'supervisor-quality-survey' as TypeEnum
    };
}


